export default __webpack_public_path__ + "static/media/notification-announcement-icon-gray.b4ba2f3e.svg";